import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const BEDROOM_OPTION_LABELS: Record<number, string> = { 7: "Duplex", 8: "Penthouse" };

/**
 * Normalizes a single bedroom value (number code, or legacy string like "3 BHK")
 * into a display label containing "BHK" exactly once.
 */
export function formatBedroomLabel(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === "") return "";

  if (typeof value === "string") {
    // Strip any existing BHK suffixes (including duplicated ones) and extra spaces
    const cleaned = value.replace(/\s*bhk\s*/gi, " ").replace(/\s+/g, " ").trim();
    if (!cleaned) return "";
    const num = Number(cleaned);
    if (Number.isFinite(num)) return formatBedroomLabel(num);
    // Non-numeric label like "Duplex", "Penthouse", "Large 3"
    return /\d/.test(cleaned) ? `${cleaned} BHK` : cleaned;
  }

  if (!Number.isFinite(value)) return "";
  return BEDROOM_OPTION_LABELS[value] ?? `${value} BHK`;
}

/** Formats bedroom option values for display: 1-6 -> "n BHK", 7 -> "Duplex", 8 -> "Penthouse". */
export function formatBedroomOptions(options: Array<number | string>): string {
  return [...(options ?? [])]
    .sort((a, b) => Number(a) - Number(b))
    .map((n) => formatBedroomLabel(n))
    .filter(Boolean)
    .join(", ");
}

